import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import TransactionFileFactory from "../../Entity/Factories/TransactionFileFactory";

export default function* transactionFileList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "transaction-file");

    const transactionFiles = res.data.map(transactionFile => {
      return TransactionFileFactory.create(transactionFile);
    })
      .sort((transactionFile1, transactionFile2) => {
        if (transactionFile1.createdAt < transactionFile2.createdAt) {
          return 1;
        }

        if (transactionFile1.createdAt > transactionFile2.createdAt) {
          return -1;
        }

        return  0;
      });

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_LIST_SUCCESS,
      payload: {
        transactionFiles: transactionFiles
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchTransactionFileList() {
  yield takeEvery(Constants.GLOBAL_TRANSACTION_FILE_LIST, transactionFileList);
}
